import { render, staticRenderFns } from "./public-holiday.vue?vue&type=template&id=5d894414&scoped=true&"
import script from "./public-holiday.vue?vue&type=script&lang=js&"
export * from "./public-holiday.vue?vue&type=script&lang=js&"
import style0 from "./public-holiday.vue?vue&type=style&index=0&id=5d894414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d894414",
  null
  
)

export default component.exports